<template>
	<div v-if="hasData" class="sk-grid">
		<card-pacient-profile :patient="patient" />
		<card-pacient-warnings :patient="patient" :datetime="datetime" />
		<card-pacient-heart-rate :patient="patient" :datetime="datetime" />
		<card-pacient-blood-pressure :patient="patient" :datetime="datetime" />
		<card-pacient-temperature :patient="patient" :datetime="datetime" />
		<card-pacient-oxygen :patient="patient" :datetime="datetime" />
		<card-pacient-location :patient="patient" :datetime="datetime" />
		<card-pacient-logs :patient="patient" :datetime="datetime" />
		<card-pacient-calories-pedometer :patient="patient" :datetime="datetime" />
		<card-pacient-upcoming-appointments :patient="patient" :datetime="datetime" />
		<card-pacient-current-prescription :patient="patient" :datetime="datetime" />
		<card-pacient-falls :patient="patient" :datetime="datetime" />
		<card-pacient-diseases :patient="patient" />
	</div>
</template>

<script>
import CardPacientBloodPressure from '@/modules/pacient/CardPacientBloodPressure'
import CardPacientCaloriesPedometer from '@/modules/pacient/CardPacientCaloriesPedometer'
import CardPacientCurrentPrescription from '@/modules/pacient/CardPacientCurrentPrescription'
import CardPacientFalls from '@/modules/pacient/CardPacientFalls'
import CardPacientHeartRate from '@/modules/pacient/CardPacientHeartRate'
import CardPacientLocation from '@/modules/pacient/CardPacientLocation'
import CardPacientProfile from '@/modules/pacient/CardPacientProfile'
import CardPacientTemperature from '@/modules/pacient/CardPacientTemperature'
import CardPacientOxygen from '@/modules/pacient/CardPacientOxygen'
import CardPacientUpcomingAppointments from '@/modules/pacient/CardPacientUpcomingAppointments'
import CardPacientWarnings from '@/modules/pacient/CardPacientWarnings'
import CardPacientLogs from '@/modules/pacient/CardPacientLogs'
import CardPacientDiseases from '@/modules/pacient/CardPacientDiseases'

export default {
	components: {
		CardPacientBloodPressure,
		CardPacientCaloriesPedometer,
		CardPacientCurrentPrescription,
		CardPacientFalls,
		CardPacientHeartRate,
		CardPacientLocation,
		CardPacientProfile,
		CardPacientTemperature,
		CardPacientOxygen,
		CardPacientUpcomingAppointments,
		CardPacientWarnings,
		CardPacientLogs,
		CardPacientDiseases
	},
	props: {
		user_uid: {
			type: String
		},
		watch_id: {
			type: Number|String
		},
		patient: {
			type: Object
		},
		datetime: {
			type: Object
		}
	},
	computed: {
		hasData() {
			return this.patient && this.patient.id !== undefined
		}
	}
}
</script>

<style scoped>
.sk-grid {
	display: grid;
	justify-content: center;
	grid-auto-rows: 320px;
	grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
	grid-gap: 20px;
}
.sk-header-padding-left {
	padding: 0 0 0 40px;
}
.sk-header-padding-right {
	padding: 0 40px 0 0;
}
.sk-header-button {
	text-decoration: none;
	font-weight: 700;
	color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/watch/WatchDashboard.vue